import type { RouteLocationNormalized, RouteLocationNormalizedLoaded, NavigationGuardNext } from 'vue-router'

/* ------- CONTEXTS - SMAG ------- */
const VSmagLayout = () => import('@b2ag/previsionnel/src/layouts/VSmagLayout.vue')
const VSmagPrevisionnel = () => import('@b2ag/previsionnel/src/application/views/VSmagPrevisionnel.vue')

export const smagRoutes = [
  {
    path: '/forecast',
    name: 'previsionnel',
    component: VSmagLayout,
    children: [
      {
        path: ':previsionnelId',
        name: 'smag-previsionnel',
        meta: {
          private: true,
          storePathBeforeAuth: true,
          name: 'smag-previsionnel', // Due to a bug known and documented in nuxt 3, we need to set a name for the route in the meta object
          showSmagNoteCard: false,
          showAppHeader: false,
          hasOwnHeader: true,
        },
        component: VSmagPrevisionnel,
        beforeEnter: (to: RouteLocationNormalized, _from: RouteLocationNormalizedLoaded, next: NavigationGuardNext) => {
          const { previsionnelId } = to.params
          const mongoObjectIdRegex = /^[0-9a-fA-F]{24}$/
          const isValidMongoObjectId = (id: string) => {
            return mongoObjectIdRegex.test(id)
          }
          if (!isValidMongoObjectId(String(previsionnelId))) next({ name: 'not-found' })
          next()
        },
        props(route: RouteLocationNormalized) {
          const { previsionnelId } = route.params
          return { previsionnelId }
        },
      },
    ],
  },
]
